import React from 'react';
import classNames from 'classnames';
import icRentalReward from 'assets/img/ic_rental_reward.png';
import styles from './styles.module.scss';

const RenterBenefitCard = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: icRentalReward,
    className: styles.imgRentalReward
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapItem
  }, /*#__PURE__*/React.createElement("li", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rewardItem
  }, "All earnings by the Hero from rented battles go to Renter.")), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapItem
  }, /*#__PURE__*/React.createElement("li", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rewardItem
  }, "Rented heroes can earn rewards from ranked battles, special events and daily quests.")));
};

export default RenterBenefitCard;